module.exports = __webpack_public_path__ + "static/media/education-object-2-2.43b7b6d8.svg";